import { render, staticRenderFns } from "./NsrFluctuation.vue?vue&type=template&id=63654316"
import script from "./NsrFluctuation.vue?vue&type=script&lang=js"
export * from "./NsrFluctuation.vue?vue&type=script&lang=js"
import style0 from "./NsrFluctuation.vue?vue&type=style&index=0&id=63654316&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports